import {
  FIELD_INFO_KEYS,
  type BubbleChartViewSettings,
  type SettableBubbleChartViewSettings,
} from '@ardoq/bubble-chart';

/**
 * A label filter records which field it was made for. Assigning a different field
 * to that axis makes the view stop applying the filter, but it stays in the
 * settings and starts applying again if the earlier field is put back. The
 * settings bar clears the filter every time an axis field is picked; this code
 * does the same.
 */
const clearsLabelFilter = (
  settings: Partial<SettableBubbleChartViewSettings>
): boolean =>
  settings.labelFilter === null ||
  (settings.labelFilter === undefined &&
    FIELD_INFO_KEYS.some(key => settings[key] !== undefined));

export const toStoredBubbleChartViewSettings = (
  settings: Partial<SettableBubbleChartViewSettings>
): Partial<BubbleChartViewSettings> => {
  const { labelFilter, ...rest } = settings;

  if (clearsLabelFilter(settings)) {
    return { ...rest, labelFilter: undefined };
  }
  if (labelFilter) {
    return { ...rest, labelFilter };
  }
  return rest;
};
